import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-documents-prompt',
  templateUrl: './documents-prompt.component.html',
  styleUrls: ['./documents-prompt.component.scss']
})
export class DocumentsPromptComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
